import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBookingInfoModel, tBookingTimeModel, tBookingModel, tBookingWithPatientInfoModel, tBookingInfoModelV2, tBookingWithPatientInfoModelV2 } from '../models/tBookingModel';
import { BookingCalendarData } from '../components/booking-calendar-dialog/booking-calendar-dialog.component';
import { ResultModel } from './tPatient.service';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class tBookingService {

  constructor(private http: HttpClient, public datePipe :DatePipe) { }

  baseurl: string = AppSettings.BaseURI;

  readonly pathName = '/tBooking';

  api_booking = this.baseurl + this.pathName;

  getBookingByPatientAndDate(shopID:string,patientID:string,date:string){
    //date format : yyyy-MM-dd
    // const payload = { shopID:shopID,patientID:patientID,date:this.datePipe.transform(date,'yyyy-mm-dd') };
    const payload = { shopID:shopID,patientID:patientID,date:date };
    return this.http.post<ResultModel>(`${this.api_booking}/bookingByPatientAndDate`,payload);
  }

  getBookingForCalendarByEmployeeID(doctorID:string){
    //Get total booking of time slot of each day
    return this.http.get<BookingCalendarData[]>(`${this.api_booking}/bookingForCalendar/${doctorID}`);
  }

  getBookingForCalendar(){
    //Get total booking of time slot of each day
    return this.http.get<BookingCalendarData[]>(this.baseurl + this.pathName + '/bookingForCalendar/');
  }

  getBookingInfoByDate(shopID: number, searchDate: string , employeeID?:string){
    if(!employeeID)
      return this.http.get<tBookingInfoModel[]>(this.baseurl + this.pathName + '/GetBookingInfo/'+shopID+'/'+searchDate);
    return this.http.get<tBookingInfoModel[]>(this.baseurl + this.pathName + '/GetBookingInfo/'+shopID+'/'+searchDate+'/'+employeeID);
  }

  getBookingInfoByDateV2(shopID: number, searchDate: string , employeeID?:string){
    if(!employeeID)
      return this.http.get<tBookingInfoModelV2[]>(this.baseurl + this.pathName + '/GetBookingInfo/'+shopID+'/'+searchDate);
    return this.http.get<tBookingInfoModelV2[]>(this.baseurl + this.pathName + '/GetBookingInfo/'+shopID+'/'+searchDate+'/'+employeeID);
  }

  getUserEmployee(userID:string){


    return this.http.get<any[]>(this.baseurl + this.pathName + '/GetEmployeeID/'+userID);
  }

  // getBookingInfoByDate(shopID: number, searchDate: string){
  //   return this.http.get<tBookingInfoModel[]>(this.baseurl + this.pathName + '/GetBookingInfo/'+shopID+'/'+searchDate);
  // }

  getBookingInfoByDate_OpenStatus(shopID: number, searchDate: string){
    return this.http.get<tBookingInfoModel[]>(this.baseurl + this.pathName + '/GetBookingInfo_OpenStatus/'+shopID+'/'+searchDate);
}

getBookingInfoByDate_OpenStatusV2(shopID: number, searchDate: string){
  return this.http.get<tBookingInfoModelV2[]>(this.baseurl + this.pathName + '/GetBookingInfo_OpenStatus/v2/'+shopID+'/'+searchDate);
}

  getBookingTimeSlot(){
    return this.http.get<tBookingTimeModel[]>(this.baseurl + this.pathName + '/GetBookingTimeSlot');
  }

  getBookingNumberInfo(shopID: number, bookingNum: string,patientID: string){
    return this.http.get<tBookingModel>(this.baseurl + this.pathName + '/'+shopID+"/"+bookingNum+"/"+patientID);
  }

  searchBookingByPhoneNumber(phoneNumer: number, bookingStatus: string){
    return this.http.get<tBookingWithPatientInfoModel[]>(this.baseurl + this.pathName + '/'+phoneNumer+"/"+bookingStatus);
  }

  searchBookingByPhoneNumberAndChiName(searchKeyWord: number, bookingStatus: string, isToday: string){
    return this.http.get<tBookingWithPatientInfoModel[]>(this.baseurl + this.pathName
      + '/searchBookingByPhoneAndChiName/' + searchKeyWord + '/' + bookingStatus + '/' + isToday);
  }

  searchBookingByPhoneNumberAndChiNameV2(searchKeyWord: number, bookingStatus: string, isToday: string){
    return this.http.get<tBookingWithPatientInfoModelV2[]>(this.baseurl + this.pathName
      + '/searchBookingByPhoneAndChiName/' + searchKeyWord + '/' + bookingStatus + '/' + isToday);
  }


  addData(data: tBookingModel){
    return this.http.post(this.baseurl + this.pathName, data);
  }

  deleteData(shopID: number , bookingNumber: string, patientID: string, lastEditUser: string){
    return this.http.delete(this.baseurl + this.pathName + '/' + shopID + '/'+ bookingNumber + '/' + patientID+'/'+lastEditUser);
  }

  updateData(data: tBookingModel){
    return this.http.put(this.baseurl + this.pathName, data);
  }

  // searchBooking(bookingNum: string, bookingStatus: string){
  //   return this.http.get<tBookingModel[]>(this.baseurl + this.pathName + '/'+bookingNum+"/"+bookingStatus);
  // }



}
